import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ListDisplay,
  ButtonPrimary,
  MessageFoundation as Message
} from '@warrenbrasil/nebraska-web';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const description = computed(() => {
  return `Aplicação prevista para ${investmentDetails.value.expectedInvestmentDate}`;
});

const details = computed(() => {
  return [
    {
      label: 'Valor do investimento',
      value: `R$ ${amountFormatted.value}`
    },
    {
      label: 'Origem',
      value: 'Conta digital'
    },
    {
      label: 'Destino',
      value: investmentDetails.value.portfolioName
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value },
    query: { tab: 'orders' }
  });
}

return { __sfc: true,router, portfolioId, amountFormatted, investmentDetails, description, details, goToPortfolio, ConclusionStep, ListDisplay, ButtonPrimary, Message }
}

})